import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { SettingsService } from '../services/settings.service';

@Pipe({
  name: 'ubicacion'
})
export class LoactionPipe implements PipeTransform {

 constructor(private locationService: SettingsService) {}

  transform(folio: string): Observable<string> {
    if (!folio) return of('—');

    return this.locationService.getUbicacionByid(folio).pipe(
      map((resp: any) => {
       
        // 🔹 Ajusta según el nombre exacto del campo en tu API
        return resp?.name || 'Sin nombre';
      }),
      catchError(() => of('No encontrada'))
    );
  }
}